// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","expertiseFormSection":"_2D6owE0-M1yuJYwMFIs2QI","expertiseFormSectionTitle":"_1NaLDtMuGNIrCR3pnV-TJt"};